// Copyright (c) 2022-2024. Sendanor <info@sendanor.fi>. All rights reserved.

import {
    MY_CLIENT_VIEW_CLASS_NAME
} from "../../../../../core/constants/className";

import {
    T_MY_CLIENT_VIEW_ADDRESS_LABEL,
    T_MY_CLIENT_VIEW_BUSINESS_ID_LABEL,
    T_MY_CLIENT_VIEW_BUSINESS_NAME_LABEL,
    T_MY_CLIENT_VIEW_EMAIL_LABEL,
    T_MY_CLIENT_VIEW_ID_LABEL,
    T_MY_CLIENT_VIEW_MOBILE_LABEL,
    T_MY_CLIENT_VIEW_NAME_LABEL,
    T_MY_CLIENT_VIEW_NO_CLIENT_FOUND_ERROR_MESSAGE,
    T_MY_CLIENT_VIEW_PHONE_LABEL,
    T_MY_CLIENT_VIEW_TITLE
} from "../../../../../core/constants/translation";
import { ComponentUtils } from "../../../../../../../io/hyperify/frontend/components/utils/ComponentUtils";
import { isArray } from "../../../../../../../io/hyperify/core/types/Array";
import { useMyClientById } from "../../../../hooks/useMyClientById";
import { useParams } from "react-router-dom";
import { Card } from "../../../../../../../io/hyperify/frontend/components/card/Card";
import { CardGrid } from "../../../../../../../io/hyperify/frontend/components/cardGrid/CardGrid";
import "./MyClientView.scss";
import { TranslationFunction } from "../../../../../../../io/hyperify/core/types/TranslationFunction";

export interface MyClientViewProps {
    readonly className ?: string;
    readonly t?: TranslationFunction;
}

export function MyClientView (props: MyClientViewProps) {
    const t: TranslationFunction = props?.t ?? ((key: string): string => key);
    const className = props?.className;
    const params = useParams();
    const clientId = params?.clientId;
    const [client] = useMyClientById(clientId);
    return (
        <div className={
            MY_CLIENT_VIEW_CLASS_NAME
            + (className? ` ${className}` : '')
        }>

            <h3>{t(T_MY_CLIENT_VIEW_TITLE)}</h3>

            <div className={`${MY_CLIENT_VIEW_CLASS_NAME}-details`}>{!client ? (
                <p className={`${MY_CLIENT_VIEW_CLASS_NAME}-details-error-message`}>{t(T_MY_CLIENT_VIEW_NO_CLIENT_FOUND_ERROR_MESSAGE)}</p>
                    ) : (
                        <CardGrid>

                            <Card className={`${MY_CLIENT_VIEW_CLASS_NAME}-details-field details-id`}
                                  label={t(T_MY_CLIENT_VIEW_ID_LABEL)}>{client.id}</Card>

                            <Card className={`${MY_CLIENT_VIEW_CLASS_NAME}-details-field details-name`}
                                  label={t(T_MY_CLIENT_VIEW_NAME_LABEL)}
                            >{client.firstname} {client.lastname}</Card>

                            {client?.company ? (
                                <Card className={`${MY_CLIENT_VIEW_CLASS_NAME}-details-field details-business-name`}
                                      label={t(T_MY_CLIENT_VIEW_BUSINESS_NAME_LABEL)}>{client.company}</Card>
                            ) : null}

                            {client?.companyCode ? (
                                <Card
                                    className={`${MY_CLIENT_VIEW_CLASS_NAME}-details-field details-business-id`}
                                    label={t(T_MY_CLIENT_VIEW_BUSINESS_ID_LABEL)}>{client.companyCode}</Card>
                            ): null}

                            <Card className={`${MY_CLIENT_VIEW_CLASS_NAME}-details-field details-email`}
                                  label={t(T_MY_CLIENT_VIEW_EMAIL_LABEL)}>{client?.email}</Card>

                            {client?.phone ? (
                                <Card className={`${MY_CLIENT_VIEW_CLASS_NAME}-details-field details-phone`}
                                      label={t(T_MY_CLIENT_VIEW_PHONE_LABEL)}>{client?.phone}</Card>
                            ) : null}

                            {client?.mobile ? (
                                <Card className={`${MY_CLIENT_VIEW_CLASS_NAME}-details-field details-mobile`}
                                      label={t(T_MY_CLIENT_VIEW_MOBILE_LABEL)}>{client?.mobile}</Card>
                            ) : null}

                            <Card className={`${MY_CLIENT_VIEW_CLASS_NAME}-details-field details-address`}
                                  label={t(T_MY_CLIENT_VIEW_ADDRESS_LABEL)}
                            >
                                {ComponentUtils.splitWithLineBreaks( isArray(client?.address) ? client.address.join('\n') : '')}<br />
                                {client?.postCode} {client?.postName}<br />
                                {client?.country}
                            </Card>

                        </CardGrid>
                )}</div>

        </div>
    );

}
